module.exports = __webpack_public_path__ + "img/coins.6080be75.svg";